import type { EditorElement, EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import type { HeadingKeywords } from 'generated/graphql';

import type { ComponentType } from 'react';
import type { THeadingLevel } from './constants';

export const HEADING_PLUGIN_ID = 'heading' as const;
export type HeadingPluginID = typeof HEADING_PLUGIN_ID;

export type HeadingPluginElement = Readonly<
  EditorElement & {
    type: HeadingPluginID;
    level: THeadingLevel; // H1, H2
  }
>;

export type HeadingPluginOptions = Readonly<
  EditorPluginOptions & {
    component?: ComponentType<any>;
    headingKeywords?: HeadingKeywords;
    isInsertingMacro?: boolean;
    // RP-6010 (M7): when false, the plugin contributes no hovering-toolbar buttons
    // (headings are created by typing a `Label:` prefix). Defaults to true.
    showHeadingToolbarActions?: boolean;
    // RP-6071 (M8b): when true, typed/pasted `Label:` keywords are NOT auto-upgraded to
    // heading nodes (they stay paragraphs, styled by the decoration). Defaults to false.
    // RP-6648 (M8d): when true, pasted fragments that already contain heading nodes are also
    // translated to paragraphs via `translateLegacyHeadings`.
    disableKeywordUpgrade?: boolean;
  }
>;

export type HeadingPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    HeadingPluginOptions & {
      pluginID: HeadingPluginID;
      component: ComponentType<any>;
      pluginName: string;
    }
>;
